import { showFooterActions } from "../../services";

export const showFooterDispatcher  = dispatch =>({

    showFooter: ()=>dispatch({type:showFooterActions.SHOW}),
    hideFooter: ()=>dispatch({type:showFooterActions.HIDE})
})